<template>
  <div
    @click.prevent="navigate($event)"
    class="w-full lg:w-1/4 md:w-1/3 sm:w-1/2 sm:p-2"
  >
    <div class="border rounded-lg">
      <div class="flex items-center justify-center flex-col bg-card mb-4">
        <div class="w-full mb-8 text-right p-2"></div>
        <div class="mb-8">
          <img
            src="https://res.cloudinary.com/lms-edc/image/upload/v1598022664/Assets/xtyc0iregn6kgurzxecp.png"
            alt=""
          />
        </div>
      </div>
      <div class="px-6">
        <h5 class="text-xl font-semibold tenant-main-color">
          {{ board.title }}
        </h5>

          <div class="flex justify-between tenant-main-color my-4">
          <p
            class="text-sm font-semibold "
          >
            Messages -> {{board.messages}}
            Comments -> {{board.comments}}
          </p>
        </div>

        <div class="flex justify-between tenant-main-color my-4">
          <p
            @click="navigate(board.id)"
            class="text-sm font-semibold cursor-pointer"
          >
            View Discussion ->
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "survey-card",
  props: ["board"],
  methods: {
    ...mapActions(["tenantDeleteSurvey"]),
    async deleteSurvey() {
      let res = await this.tenantDeleteSurvey({
        id: this.survey.id,
      });

      this.$emit("notify", {
        type: "success",
        message: "Survey deleted successfully",
      });

      window.location.reload();
    },
    navigate(e) {
      e.stopImmediatePropagation();
      if (e.target.id == "edit") {
        this.$router.push({
          name: "tenant-survey-edit",
          params: { survey_id: this.survey.id },
        });
      } else if (e.target.id === "delete") {
        if (confirm("Are you sure you want to delete this survey?")) {
          this.deleteSurvey();
        }
      } else {
        this.$router.push({
          name: "tenant-discussion-single",
          params: { id: this.board.id },
        });
      }
    },
  },
};
</script>
<style lang="scss">
.bg-card {
  background-color: color(lms-tenant);
}
</style>
